/** @format */

import React, { useState } from 'react'
import classNames from 'classnames'

import styles from './label.module.scss'

export const Label = ({ side, text, event, color }) => {
  const [hover, setHover] = useState(false)

  const handleHover = () => setHover(!hover)
  const handleEvent = () => !!event && event(text)

  const labelStyle = classNames({
    [styles.wrapper]: true,
    [styles[side]]: !!side,
    [styles.hover]: !!event && hover,
  })

  return (
    <label
      style={{ color }}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
      onClick={handleEvent}
      className={labelStyle}
    >
      {text}
    </label>
  )
}
